
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/what-is-body-composition",
      function () {
        return require("private-next-pages/learn/what-is-body-composition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/what-is-body-composition"])
      });
    }
  